import zxcvbn from "zxcvbn";

const toNumber = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

const MIN_PASSWORD_LENGTH = toNumber(
    process.env.REACT_APP_PASSWORD_MIN_LENGTH || process.env.PASSWORD_MIN_LENGTH,
    12
);
const INTERNAL_MIN_SCORE = toNumber(
    process.env.REACT_APP_PASSWORD_MIN_STRENGTH_SCORE ||
        process.env.PASSWORD_MIN_STRENGTH_SCORE,
    3
);
const CLIENT_MIN_SCORE = 2;

const SPECIAL_REGEX = /[!@#$%^&*]/;

const scoreToLabel = (score) => {
    if (score <= 1) return "Weak";
    if (score === 2) return "Fair";
    if (score === 3) return "Good";
    return "Strong";
};

const scoreToClass = (score) => {
    if (score <= 1) return "strength-weak";
    if (score === 2) return "strength-fair";
    if (score === 3) return "strength-good";
    return "strength-strong";
};

export const evaluatePasswordStrength = (password, { role } = {}) => {
    const value = String(password || "");
    const result = zxcvbn(value);
    const requiredScore = role === "internal_staff" ? INTERNAL_MIN_SCORE : CLIENT_MIN_SCORE;

    const requirements = {
        length: value.length >= MIN_PASSWORD_LENGTH,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /\d/.test(value),
        special: SPECIAL_REGEX.test(value),
        score: result.score >= requiredScore,
    };

    const isValid = Object.values(requirements).every(Boolean);

    return {
        score: result.score,
        requiredScore,
        minLength: MIN_PASSWORD_LENGTH,
        requirements,
        feedback: result.feedback || {},
        isValid,
        scoreLabel: scoreToLabel(result.score),
        scoreClass: scoreToClass(result.score),
    };
};
